// extracted by mini-css-extract-plugin
export default {"header":"Login-Page_header__AmASI","page__container":"Login-Page_page__container__Kv25S","form__wrapper":"Login-Page_form__wrapper__30-UA","greyLogo":"Login-Page_greyLogo__AHK-i"};